import { render, staticRenderFns } from "./DisplayByRoomsV2.vue?vue&type=template&id=2b9f5988&scoped=true"
import script from "./DisplayByRoomsV2.vue?vue&type=script&lang=js"
export * from "./DisplayByRoomsV2.vue?vue&type=script&lang=js"
import style0 from "./DisplayByRoomsV2.vue?vue&type=style&index=0&id=2b9f5988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f5988",
  null
  
)

export default component.exports